<template>
  <v-container fluid ma-0 pa-0 px-1>
    <v-fab-transition>
      <v-btn
        fab
        color="primary"
        x-small
        dark
        v-show="!drawer"
        @click="openSidebar"
        absolute
        style="top:20px; left:18px"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-navigation-drawer
      width="450"
      :value="drawer"
      disable-resize-watcher
      :mobile-breakpoint="0"
      app
      clipped
      left
      style="left:56px"
    >
      <help-layout-left></help-layout-left>
    </v-navigation-drawer>
    <!-- If using vue-router -->
    <transition-page>
      <router-view></router-view>
    </transition-page>
  </v-container>
</template>

<script>
import TransitionPage from "@/components/TransitionPage.vue";

//Layout Components
import HelpLayoutLeft from "@/components/HelpLayoutLeft";
export default {
  components: {
    TransitionPage,
    HelpLayoutLeft
  },
  data() {
    return {
      componentKey: 0

      //drawerRight: null,
      //right: false,
      //left: false
    };
  },
  props: {},
  methods: {
    openSidebar() {
      this.$store.dispatch("toggleDashBoardDrawer");
    },
    forceRenderer() {
      this.componentKey += 1;
    }
  },
  watch: {},
  computed: {
    drawer() {
      return this.$store.getters.dashboardDrawer;
    }
  }
};
</script>
